export type AuthenticateUserDataType = {
  accessToken: string;
  refreshToken: string;
  userUuid: string;
};

export type AuthenticateUserRequestType = {
  clientUuid: string;
  email: string;
  password: string;
};

export type FetchClientDataType = {
  client: {
    currencyIso: string;
    company: string;
    logoUrl?: string;
  };
};

export const stripeAccountType = {
  PLATFORM: "platform",
  CONNECT: "connect",
} as const;

export const IsoCurrencyCodes = {
  CANADA: "CAD",
  USA: "USD",
} as const;

export const RequestType = {
  BANK: "bank",
  CARD: "card",
} as const;
